import { render, staticRenderFns } from "./JobInstruction.vue?vue&type=template&id=394c7040&scoped=true"
import script from "./JobInstruction.vue?vue&type=script&lang=js"
export * from "./JobInstruction.vue?vue&type=script&lang=js"
import style0 from "./JobInstruction.vue?vue&type=style&index=0&id=394c7040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394c7040",
  null
  
)

export default component.exports